import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const PageSEO = ({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  article = false,
  publishedTime,
  modifiedTime
}) => {
  // Direct document.title manipulation for immediate effect
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  const fullTitle = title || 'Evidentica - Research Intelligence Platform';
  const fullDescription = description || 'Advanced research intelligence platform for discovering, analyzing, and evaluating scientific articles with AI-powered insights.';
  const fullKeywords = keywords || 'research, scientific articles, evidence-based medicine, research analysis, AI insights, medical research';
  const canonicalUrl = canonical || process.env.REACT_APP_BACKEND_URL || '';
  const imageUrl = ogImage || `${process.env.REACT_APP_BACKEND_URL || ''}/og-image.png`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={fullKeywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={article ? 'article' : 'website'} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Evidentica" />
      
      {article && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {article && modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* Robots */}
      <meta name="robots" content="index, follow, max-image-preview:large" />
    </Helmet>
  );
};

export default PageSEO;
